import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSession } from '../../utils/authUtils';
import GoogleOAuthService from '../../services/GoogleOAuthService';
import logo from '../../assets/VisibeenLogo.png';
import logo1 from '../../assets/googleLogo.jpg';

import logger from '../../utils/logger';
function GoogleConnect() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const currentUser = getSession();

    const handleGoogleConnect = async () => {
        try {
            setLoading(true);
            setError('');

            // Get user email for login hint
            const userEmail = currentUser?.email;

            // Initiate OAuth flow - this will redirect to Google
            await GoogleOAuthService.initiateOAuthFlow({
                forceConsent: true, // Always force consent to get refresh token
                loginHint: userEmail // Pre-select user's account
            });
        } catch (error) {
            logger.error('Google connect error:', error);
            setError(error.message || 'Failed to connect Google account');
            setLoading(false);
        }
    };

    const handleSkip = () => {
        // If user skips, redirect to account not found since we can't verify GMB
        navigate('/account-not-found');
    };

    return (
        <div className="main-container">
            <div className="left-side">
                <img src={logo} alt="logo" id='img' />
                <div className="left-content">
                    <h2>Connect Your Google Account</h2>
                    <p>To verify your <b>Google My Business</b> access, please connect your Google account.</p>
                </div>
            </div>

            <div className="right-side">
                <div className="login-container">
                    <h2>Link Google Account</h2>
                    <p className="subtitle">Connect your Google account to check for Google My Business access</p>

                    {error && <p style={{ color: 'red' }}>{error}</p>}

                    <button
                        className="google-btn"
                        onClick={handleGoogleConnect}
                        disabled={loading}
                    >
                        <span>
                            <img src={logo1} alt="GoogleLogo" id='googleLogo' />
                        </span>
                        {loading ? 'Connecting...' : 'Connect with Google'}
                    </button>

                    <div className="divider">
                        <span>or</span>
                    </div>

                    <button
                        type="button"
                        className="skip-btn"
                        onClick={handleSkip}
                        style={{
                            width: '100%',
                            padding: '12px',
                            border: '2px solid #e5e7eb',
                            borderRadius: '8px',
                            background: 'white',
                            color: '#6b7280',
                            fontSize: '16px',
                            cursor: 'pointer',
                            marginTop: '10px'
                        }}
                    >
                        Skip for Now
                    </button>

                    <p style={{ textAlign: 'center', fontSize: '14px', color: '#6b7280', marginTop: '20px' }}>
                        Note: Without connecting your Google account, we cannot verify your Google My Business access.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default GoogleConnect;

